import { render, staticRenderFns } from "./ActionPersonPasser.vue?vue&type=template&id=03189ffa"
import script from "./ActionPersonPasser.vue?vue&type=script&lang=js"
export * from "./ActionPersonPasser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports